import {ActionList} from '@primer/react'
import {useFeatureFlags} from '@github-ui/react-core/use-feature-flag'

import {CommentsPreference} from '../types'
import {useUpdateUserDiffViewPreferenceMutation} from '../hooks/mutations/use-update-user-diff-view-preference-mutation'
import {useDiffViewSettingsData} from '../page-data/payloads/diff-view-settings'

export function DiffCommentsPreferenceToggle() {
  const {diff_inline_comments: diffInlineCommentsFeatureIsEnabled, prx_files: prxFilesIsEnabled} = useFeatureFlags()
  const {data} = useDiffViewSettingsData()
  const {mutate: updateUserDiffViewPreference} = useUpdateUserDiffViewPreferenceMutation({
    onSuccess: () => {},
    onError: () => {},
  })

  if (!data) return null
  if (!(diffInlineCommentsFeatureIsEnabled || prxFilesIsEnabled)) return null

  const isCollapsed = data.commentsPreference === CommentsPreference.Collapsed

  return (
    <>
      <ActionList.Divider />
      <ActionList.Group aria-label="Comments" selectionVariant="single">
        <ActionList.Item
          role="menuitemcheckbox"
          selected={isCollapsed}
          onSelect={() =>
            updateUserDiffViewPreference({
              commentsPreference: isCollapsed ? CommentsPreference.Visible : CommentsPreference.Collapsed,
            })
          }
        >
          Minimize comments
        </ActionList.Item>
      </ActionList.Group>
    </>
  )
}

try{ DiffCommentsPreferenceToggle.displayName ||= 'DiffCommentsPreferenceToggle' } catch {}